var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScarf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.966,
    height: 56,
    viewBox: "0 0 56.966 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.585 4.336)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,3.125h2.646a10.678,10.678,0,0,1,7.48,3.043,7.282,7.282,0,0,1,2.2,5.2v11.7",
    transform: "translate(-2.358 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.627,19.384c0,3.122-4.34,6.287-7.939,6.287-2.646,0-7.939-.5-7.939-11.273S18.822,3.125,21.689,3.125c5.292,0,7.939,2.324,7.939,5.2V39.544l10.585,5.2V18.308a7.283,7.283,0,0,0-2.2-5.2l-3.1-3.043",
    transform: "translate(-4.929 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.974,3.125h-4.7a5.625,5.625,0,0,0-3.908,1.57L12.283,6.724a5.417,5.417,0,0,0-1.658,3.885v9.859",
    transform: "translate(-6.215 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.627,10c0,3.035-4.34,6.07-7.939,6.07-2.717,0-7.939-2.757-7.939-6.07",
    transform: "translate(-4.929 -0.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.91,8.125l-2.787,2.74A5.408,5.408,0,0,0,7.5,14.724v2.289c0,11.923,10.435,16.259,15,16.259,4.34,0,9.7-3.1,9.7-6.07",
    transform: "translate(-7.5 -1.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.085,29.551V39.9L7.5,34.7V15.625",
    transform: "translate(-7.5 1.718)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.203,
    transform: "translate(35.283 41.622)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 4.986,
    transform: "translate(31.755 40.105)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.203,
    transform: "translate(28.227 38.154)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.203,
    transform: "translate(24.698 36.419)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.203,
    transform: "translate(10.585 41.622)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.203,
    transform: "translate(7.057 39.888)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.203,
    transform: "translate(3.528 38.154)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.203,
    transform: "translate(0 36.419)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 56.966,
    height: 56
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScarf);
export default __webpack_public_path__ + "static/media/Scarf.2b8ea1612ef6c0a27929963cfe6f365f.svg";
export { ForwardRef as ReactComponent };